import { Box, Button, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import React from "react";
import { Avatar } from "@mui/material";
import { IconButton, Grid } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import FooterNav from "./FooterNav";
import { setOpen, toggleOpen } from "../redux/slices/alertOpen";
import { unsetCookie } from "./Login";
import axiosInstance from "../AxiosBaseApi";

const My = () => {
  const userInfo = useSelector((state) => state.userdata);
  const openalert = useSelector((state) => state.openAlert);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [data, SetData] = useState("");
  const [earning, setEarning] = useState();
  const [bonus, setBonus] = useState('');
  
  const [plans, setPlans] = useState([]);
  const handleOpen = () => {
    dispatch(setOpen(true)); // Sets state to true
  };

  const handleClose = () => dispatch(toggleOpen());

  const getPlans = async (uid) => {
    try {
      const response = await axiosInstance
        .get(`/get_wellet.php?userid=${uid}`)

        .then((res) => {
          if (res.status === 200) {
            console.log(res.data.earnings);
            setEarning(res.data.earnings);
            setPlans(res.data.plans);
            setBonus(res.data.bonus);
          } else {
            alert(res.data.message);
          }
        });
    } catch (error) {
      console.log("Error", error);
    }
  };
  const getUserData = async (uid) => {
    try {
      const response = await axiosInstance
        .get(`/bet.php?action=getuserinfo&user=${uid}`)

        .then((res) => {
          if (res.status === 200) {
            SetData(res.data);
            getPlans(uid);
          } else {
            alert(res.data.message);
          }
        });
    } catch (error) {
      console.log("Error", error);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("mamberId");
    if (!token) {
      navigate("/login");
    } else {
      getUserData(token);
    }
  }, []);

  const handleNavigation = (path) => {
    navigate(path);
  };

  const logOut = () => {
    unsetCookie();
    navigate("/login");
  };
  return (
    <>
      <div
        style={{
          width: "100%",
          marginBottom: "60px",
          // height: "2vh",
          background: "url(/images/back.png) top / 100% 200px no-repeat",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            padding: 2,
            height: "25vh",
          }}
        >
          <img
            src="images/imgmy.png"
            alt="Icon"
            style={{ width: 50, height: 50 }}
          />

          <Box>
            <Typography variant="body1" color="#3d3b6f">
              {data[0]?.username}
            </Typography>
          </Box>

          <Typography variant="subtitle2" color="#3d3b6f">
            Nick name: {data[0]?.nickname}
          </Typography>
        </Box>

        <Box
          style={{
            display: "flex",
            padding: "0 10px",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="body1" color="#3d3b6f">
            Balance:
          </Typography>
          <Typography variant="body1" color="#3d3b6f">
            User code:
          </Typography>
        </Box>
        <Box
          style={{
            display: "flex",
            padding: "0 10px",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h4" color="#3d3b6f">
          {data[0]?.balance} 
          </Typography>
          <Typography variant="h4" color="#3d3b6f">
            {data[0]?.usercode}
          </Typography>
        </Box>

        <Box
          style={{
            display: "flex",
            padding: "0 10px",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="body1" color="#3d3b6f">
            Personal wallet:
          </Typography>
        </Box>
        <Box
          style={{
            display: "flex",
            padding: "0 10px",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h4" color="#3d3b6f">
            {data[0]?.pmain}
          </Typography>
          {/* <Typography variant="h4" color="#fff">
            Intern
          </Typography> */}
        </Box>

        <Box
          style={{
            display: "flex",
            padding: "0 10px",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            width: "100%",
          }}
        >
          <Typography variant="body1" color="#3d3b6f">
            Effective date:
          </Typography>
          <Typography variant="body1" color="#3d3b6f">
            {plans[0]?.start_date} ~ {plans[0]?.end_date}
          </Typography>
        </Box>

        <Box
          // elevation={1}
          sx={{
            position: "relative",
            // top: "-5.18667rem",
            display: "flex",
            flexWrap: "wrap",
            minHeight: 160,
            margin: 1.5,
            borderRadius: "10px",
          }}
        >
          <Box
            sx={{
              padding: "10px",
              border: "1px solid #3d3b6f",
              // backgroundColor: "#fff",
              width: "100%",
              borderRadius: "10px",
            }}
          >
            <Box
              style={{
                display: "flex",
                padding: "0 10px",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <Typography variant="body1" color="#3d3b6f">
                Job security deposit
              </Typography>
              <Typography variant="body1" color="#3d3b6f">
              {plans[0]?.deposit_amount}
              </Typography>
            </Box>
            <Box
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box
                style={{
                  border: "1px solid #3d3b6f",
                  display: "flex",
                  padding: "10px",
                  width: "30%",
                  minHeight: "72px",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <Typography variant="body1" color="#3d3b6f">
                  Yesterday's earnings
                </Typography>
                <Typography variant="body1" color="#3d3b6f">
                  {earning?.yesterday}
                </Typography>
              </Box>
              <Box
                style={{
                  border: "1px solid #3d3b6f",
                  display: "flex",
                  padding: "10px",
                  width: "30%",
                  minHeight: "72px",
                  // justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <Typography variant="body1" color="#3d3b6f">
                  Today earnings
                </Typography>
                <Typography variant="body1" color="#3d3b6f">
                  {earning?.today}
                </Typography>
              </Box>
              <Box
                style={{
                  border: "1px solid #3d3b6f",
                  display: "flex",
                  padding: "10px",
                  width: "30%",
                  minHeight: "72px",
                  // justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <Typography variant="body1" color="#3d3b6f">
                  Total earnings
                </Typography>
                <Typography variant="body1" color="#3d3b6f">
                  {earning?.total}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            minHeight: 60,
            // width: "90%",
            margin: "0 10px",
            position: "relative",
            // top: "-3rem",
            borderRadius: "5px",
            marginBottom: "70px",
            // backgroundColor: "#fff",
          }}
        >
          {/* Gifts Section */}
          <Box
            // onClick={() => handleNavigation("/redenvelopes")}
            style={{
              display: "flex",
              border: "1px solid #3d3b6f",
              justifyContent: "space-between",
              padding: "10px",
              marginBottom: "10px",
            }}
          >
            <Typography style={{ color: "#3d3b6f" }}>
              Earnings this week
            </Typography>
            <Typography style={{ color: "#3d3b6f" }}>
              {earning?.this_week}
            </Typography>
          </Box>
          <Box
            // onClick={() => handleNavigation("/redenvelopes")}
            style={{
              display: "flex",
              border: "1px solid #3d3b6f",
              justifyContent: "space-between",
              padding: "10px",
              marginBottom: "10px",
            }}
          >
            <Typography style={{ color: "#3d3b6f" }}>
              This month's earnings
            </Typography>
            <Typography style={{ color: "#3d3b6f" }}>
              {earning?.this_month}
            </Typography>
          </Box>
          <Box
            // onClick={() => handleNavigation("/redenvelopes")}
            style={{
              display: "flex",
              border: "1px solid #3d3b6f",
              justifyContent: "space-between",
              padding: "10px",
              marginBottom: "10px",
            }}
          >
            <Typography style={{ color: "#3d3b6f" }}>
              Task commission from the team
            </Typography>
            <Typography style={{ color: "#3d3b6f" }}>{bonus}</Typography>
          </Box>
          <Box
            // onClick={() => handleNavigation("/redenvelopes")}
            style={{
              display: "flex",
              border: "1px solid #3d3b6f",
              justifyContent: "space-between",
              padding: "10px",
            }}
          >
            <Typography style={{ color: "#3d3b6f" }}>
              Recommended income
            </Typography>
            <Typography style={{ color: "#3d3b6f" }}>0.00</Typography>
          </Box>
        </Box>
      </div>
      {/* <Box style={{ marginTop: "60px" }}> */}
      <FooterNav />
      {/* </Box> */}
    </>
  );
};
export default My;
